// Port of api/fuel/app/classes/filter/search/games/filters/query/play/date/never.php
export default {
	name: 'play.date.never',
	priority: 58,
	require: function(config, filter) {
		return filter.played && filter.played.never && (filter.played.never.from || filter.played.never.to)
	},
	run: function(config, filter, data, query) {
		if (filter.played.never.from) query.where('pn.play_date', '>=', filter.played.never.from)
		if (filter.played.never.to) query.where('pn.play_date', '<=', filter.played.never.to)
		query.notexist('play', 'pn')
	}
}
